export default __webpack_public_path__ + "static/construction-94cd30dd4e94ae166ce5d21edc7767aa.png";